import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
    import {computed, PropType} from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectedTags',
  props: {
        tags: {
            type: Object as PropType<Tag[]>,
            required: true,
        },
    },
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const formattedTags = computed(() => {
        return props.tags?.map((tag) => {
            return {
                label: tag.name,
                id: tag.sanitize(),
                value: tag.name,
            };
        });
    });

    const emits = __emit;

    function handlerRemove(tagName: string) {
        emits('remove', {name: tagName});
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyTagsList = _resolveComponent("VJoyTagsList")!

  return (_openBlock(), _createBlock(_component_VJoyTagsList, {
    removable: "",
    tags: formattedTags.value,
    onRemoveTag: handlerRemove
  }, null, 8, ["tags"]))
}
}

})